import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c31eb20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-content" }

import { useStore } from "@/store";
import importJson from "@/utils/importer";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const { addSnake } = useStore();

function load() {
  const snakes = importJson(
    [
      {
        blocks: [
          "prom-const-1",
          "ctrl-EL222",
          "ctrl-PhyB",
          "ctrl-PIF3",
          "term-1",
        ],
      },
      {
        blocks: [
          "prom-activ-EL222dim",
          "seq-recog-recomb2",
          "meta-recomb1",
          "term-1",
          "seq-recog-recomb2",
          "visi-GFP",
          "term-1",
        ],
      },
      {
        blocks: [
          "prom-activ-PhyBPIF3",
          "seq-recog-recomb1",
          "meta-kill",
          "term-1",
          "seq-recog-recomb1",
          "meta-recomb2",
          "term-1",
        ],
      },
    ],
    1
  );
  addSnake(...snakes);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", { onClick: load }, _toDisplayString(_unref(t)("load.loadUTokyo2022Project")), 1)
  ]))
}
}

})